import React, { useMemo } from 'react';
import Tabs from '../../layout/Tabs';

type Props = {
  active: string;
  id?: string;
  hasExportAccess: boolean;
  hasDevtoolsAccess: boolean;
  hasAdHocAccess: boolean;
};

const ClinicTabs: React.FC<Props> = ({
  active,
  id,
  hasExportAccess,
  hasDevtoolsAccess,
  hasAdHocAccess,
}) => {
  const tabsToUse = useMemo(() => {
    const theTabs = [
      {
        name: 'General',
        href: `/clinics/${id}`,
        active: active === `/clinics/${id}`,
      },
      {
        name: 'Users',
        href: `/clinics/${id}/users`,
        active: active === `/clinics/${id}/users`,
      },
      {
        name: 'Locations',
        href: `/clinics/${id}/locations`,
        active: active === `/clinics/${id}/locations`,
      },
      {
        name: 'Billing',
        href: `/clinics/${id}/billing`,
        active: active === `/clinics/${id}/billing`,
      },
      {
        name: 'Integrations',
        href: `/clinics/${id}/integrations`,
        active: active === `/clinics/${id}/integrations`,
      },
      {
        name: 'Payments',
        href: `/clinics/${id}/payments`,
        active: active === `/clinics/${id}/payments`,
      },
    ];

    if (hasDevtoolsAccess) {
      theTabs.push(
        {
          name: 'Patients',
          href: `/clinics/${id}/patients`,
          active: active === `/clinics/${id}/patients`,
        },
        {
          name: 'Debug+',
          href: `/clinics/${id}/debug`,
          active: active === `/clinics/${id}/debug`,
        }
      );
    }

    if (hasExportAccess) {
      theTabs.push({
        name: 'Exports',
        href: `/clinics/${id}/exports`,
        active: active === `/clinics/${id}/exports`,
      });
    }

    if (hasAdHocAccess) {
      theTabs.push({
        name: 'Ad Hoc Reports',
        href: `/clinics/${id}/ad-hoc-reports`,
        active: active === `/clinics/${id}/ad-hoc-reports`,
      });
    }

    return theTabs;
  }, [active, id, hasExportAccess, hasDevtoolsAccess, hasAdHocAccess]);

  return <Tabs tabs={tabsToUse} />;
};

export default ClinicTabs;
